const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작성일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['재해형태', '작성일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.section"
      },
      {
        "name": "평가종류",
        "key": "body.inputA_1"
      },
      {
        "name": "평가자",
        "key": "body.inputA_2"
      },
      {
        "name": "1~2(L)",
        "key": "body.sum_L"
      },
      {
        "name": "3~4(ML)",
        "key": "body.sum_ML"
      },
      {
        "name": "6(M)",
        "key": "body.sum_M"
      },
      {
        "name": "8~9(H)",
        "key": "body.sum_H"
      },
      {
        "name": "12~16(HH)",
        "key": "body.sum_HH"
      },
      {
        "name": "작성일",
        "key": "created_at"
      },
    ]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.section // 회사명
        case 1: return func.getContent(value).inputA_1 // 평가종류
        case 2: return func.getContent(value).inputA_2 // 평가자
        case 3: return func.getContent(value).sum_L.toString() // 합계
        case 4: return func.getContent(value).sum_ML.toString() // 합계
        case 5: return func.getContent(value).sum_M.toString() // 합계
        case 6: return func.getContent(value).sum_H.toString() // 합계
        case 7: return func.getContent(value).sum_HH.toString() // 합계
        case 8: return func.getCreatedDate(value.created_at) // 작성일

      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
